(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["option-value"] && !Shopify.designMode) return;
  try {
    if (!window.__ndBuyButtonsInit) {
  window.__ndBuyButtonsInit = true;

  const variantInputs = document.querySelectorAll('.variant-picker input');
  let url = window.location.pathname;

  function getDefaultText() {
    return url === "/products/gift-card" ? "Select Denominations" : "Select Size";
  }

  function getAllBuyButtons() {
    return document.querySelectorAll('.buy-buttons button');
  }

  getAllBuyButtons().forEach(btn => btn.textContent = getDefaultText());

  variantInputs.forEach(input => {
    input.replaceWith(input.cloneNode(true));
  });
  document.querySelectorAll('.variant-picker input:checked').forEach(input => input.checked = false);

  document.addEventListener('change', function(e) {
    if (e.target.closest('.variant-picker input')) {
      const anySelected = document.querySelector('.variant-picker input:checked');
      getAllBuyButtons().forEach(btn => {
        btn.textContent = anySelected ? "Add to Cart" : getDefaultText();
      });
    }
  });

  document.addEventListener('click', function(e) {
    const clickedButton = e.target.closest('.buy-buttons button');
    if (!clickedButton) return;

    const anySelected = document.querySelector('.variant-picker input:checked');
    if (!anySelected) {
      e.preventDefault();
      document.querySelector('.cart_error').style.display = 'block';
      getAllBuyButtons().forEach(btn => btn.textContent = getDefaultText());
      document.getElementById('select_size').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    document.querySelector('.cart_error').style.display = 'none';
  });

  // ---- Sticky ATC visibility logic (re-attaches after AJAX re-render) ----
  let stickyObserver = null;

  function initStickyObserver() {
    const mainBuyButtonWrapper = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"] .buy-buttons');
    const stickyAddWrapper = document.querySelector('.button_sticky_add');

    if (!mainBuyButtonWrapper || !stickyAddWrapper) return;

    if (stickyObserver) {
      stickyObserver.disconnect();
    }

    stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyAddWrapper.style.display = entry.isIntersecting ? 'none' : '';
      });
    }, {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    });

    stickyObserver.observe(mainBuyButtonWrapper);
  }

  initStickyObserver();

  // Re-attach observer whenever product-rerender swaps the DOM (variant change, AJAX update)
  const rerenderTargets = document.querySelectorAll('product-rerender');
  let debounceTimer = null;

  rerenderTargets.forEach(target => {
    const mutationObserver = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(initStickyObserver, 50);
    });

    mutationObserver.observe(target, { childList: true, subtree: true });
  });
}
  } catch(e) { console.error(e); }
})();

})();
